/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useEffect, useLayoutEffect, useRef } from "react";
import {
  useGLTF,
  CurveModifier,
  Text3D,
  CurveModifierRef,
} from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { fontFilePaths } from "../fonts/fontFilePaths";

export const TwoPMTextMobile = () => {
  const textRef = useRef<THREE.Mesh>(null);
  const textRef2 = useRef<THREE.Mesh>(null);
  const textRef3 = useRef<THREE.Mesh>(null);

  const fontNames = fontFilePaths;
  useLayoutEffect(() => {
    if (!textRef.current) return;
    const box = new THREE.Box3().setFromObject(textRef.current);
    const center = new THREE.Vector3();
    box.getCenter(center);
    textRef.current.position.sub(center); // move text so its center is at (0,0,0)

    if (!textRef2.current) return;
    const box2 = new THREE.Box3().setFromObject(textRef2.current);
    const center2 = new THREE.Vector3();
    box2.getCenter(center2);
    textRef2.current.position.sub(center2); // move text so its center is at (0,0,0)

    if (!textRef3.current) return;
    const box3 = new THREE.Box3().setFromObject(textRef3.current);
    const center3 = new THREE.Vector3();
    box3.getCenter(center3);
    textRef3.current.position.sub(center3); // move text so its center is at (0,0,0)
  }, []);

  const size = -350;
  return (
    <group position={[0, 0, -800]}>
      {/* <directionalLight color="white" position={[0, 0, 15]} layers={1} /> */}
      {/* <CircularText /> */}
      <group position={[0, 0, 0]}>
        <Text3D
          ref={textRef}
          font={fontNames[9]} // Make sure to use a valid font path
          size={size}
          bevelEnabled
          bevelThickness={0.05}
          bevelSize={0.01}
          bevelOffset={0}
          bevelSegments={64}
          rotation={[0, 0, Math.PI]} // Rotate the text to correct orientation
        >
          2PM2PM2PM
          <meshPhysicalMaterial color="white" />
        </Text3D>
      </group>
      <group position={[0, -400, 0]}>
        <Text3D
          ref={textRef2}
          font={fontNames[9]} // Make sure to use a valid font path
          size={size}
          bevelEnabled
          bevelThickness={0.05}
          bevelSize={0.01}
          bevelOffset={0}
          bevelSegments={64}
          rotation={[0, 0, Math.PI]} // Rotate the text to correct orientation
        >
          2PM2PM2PM
          <meshPhysicalMaterial color="white" />
        </Text3D>
      </group>
      <group position={[0, 400, 0]}>
        <Text3D
          ref={textRef3}
          font={fontNames[9]} // Make sure to use a valid font path
          size={size}
          bevelEnabled
          bevelThickness={0.05}
          bevelSize={0.01}
          bevelOffset={0}
          bevelSegments={64}
          rotation={[0, 0, Math.PI]} // Rotate the text to correct orientation
        >
          2PM2PM2PM
          <meshPhysicalMaterial color="white" />
        </Text3D>
      </group>
    </group>
  );
};

useGLTF.preload("/models/scene-v1.glb");
